import { render, staticRenderFns } from "./ProjectPresetItem.vue?vue&type=template&id=79290378&scoped=true&"
import script from "./ProjectPresetItem.vue?vue&type=script&lang=js&"
export * from "./ProjectPresetItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPresetItem.vue?vue&type=style&index=0&id=79290378&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79290378",
  null
  
)

export default component.exports